import { REMAINING_LIMITS_CATEGORY } from "@letsbit/malcolmlb";
import { LimitBar } from "@letsbit/milkylb";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";

import { messages } from "./messages";
import { LimitsProps } from "./types";

import "./styles.scss";
import classNames from "classnames";
import { useLimitsComponent } from "./useLimitsComponent";

export const Limits: React.FC<LimitsProps> = ({
  limitParams,
  period,
  classname,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { limits, getInfo } = useLimitsComponent({ limitParams, period });

  return limits && limits?.length > 0 ? (
    <div className={classNames(classname, "flex flex-col gap-2")}>
      {limits.map((limit) => {
        const limitInfo = getInfo(limit);
        if (
          limit.category !== REMAINING_LIMITS_CATEGORY.COIN_CONVERTED &&
          limitInfo.percent < 0.5
        ) {
          return undefined;
        }
        return (
          <LimitBar
            className={classnames("limits")}
            key={limit.currency + limit.time_period + limit.value}
            text={
              <FormattedMessage
                {...messages.aLotRemaining}
                values={{
                  operation: limitInfo.operationText,
                  remaining:
                    limit.category !== REMAINING_LIMITS_CATEGORY.COIN_CONVERTED
                      ? limitInfo.remainingText
                      : limitInfo.remainingConverted,
                  ticker:
                    limit.category !== REMAINING_LIMITS_CATEGORY.COIN_CONVERTED
                      ? limitInfo.tickerIdText
                      : limitInfo.currencyConverted,
                  period: limitInfo.periodText,
                }}
              />
            }
            subtitle={
              limit.category === REMAINING_LIMITS_CATEGORY.COIN_CONVERTED ? (
                <FormattedMessage
                  {...messages.subtitle}
                  values={{
                    operation: limitInfo.operationText,
                    value: limitInfo.remainingText,
                    currency: limitInfo.tickerIdText,
                  }}
                />
              ) : undefined
            }
            link={{
              text: intl.formatMessage(messages.link),
              onClick: () => navigate("/logged/profile/limits"),
            }}
            percent={limitInfo.percent}
          />
        );
      })}
    </div>
  ) : null;
};
